import { Trans } from 'react-i18next';

import { Button } from '@/uikit/components';

import styles from './WelcomeApp.module.scss';

interface WelcomeAppProps {
  onSubmit: () => void;
}
export const WelcomeApp = ({ onSubmit }: WelcomeAppProps): React.ReactNode => {
  return (
    <div className={styles.container}>
      <div className={styles.container__content}>
        <h3 className={styles.container__title}>
          <Trans i18nKey="onboarding.step1.title">
            Unlock the Full Picture of Anyone Online
          </Trans>
        </h3>
        <p className={styles.container__description}>
          <Trans i18nKey="onboarding.step1.description">
            Discover social media profiles, photos, videos, and professional
            details instantly!
          </Trans>
        </p>
      </div>

      <Button onClick={onSubmit} size="xl" className={styles.container__button}>
        <Trans i18nKey="continueButton">Continue</Trans>
      </Button>
    </div>
  );
};
